<div *nzModalTitle>Add Definition: {{definitionName}}</div>

<app-definition-form
  [name]="definitionName"
  [categories]="categoryList"
  mode="add"
  (definitionEdited)="onSubmitSuccess()"
></app-definition-form>
